export default {
  create: {
    method: 'post',
    url: '/partner/bank/cooperatorId'
  },
  update: {
    method: 'put',
    url: '/partner/bank/cooperatorId/bankId'
  },
  delete: {
    method: 'delete',
    url: '/partner/bank/cooperatorId/delete'
  },
  detail: {
    method: 'get',
    url: '/partner/bank/cooperatorId/bankId'
  },
  archive: {
    method: 'delete',
    url: '/partner/bank/archive'
  },
  restore: {
    method: 'put',
    url: '/partner/bank/restore'
  }
}
